import React from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { Pages } from '../AppRouter';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
    const history = useHistory();
    const { t } = useTranslation();

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '60vh' }}>
            <Result
                status="404"
                title="404"
                subTitle={t("Sorry, the page you visited does not exist.")}
                extra={<Button type="primary" onClick={() => history.push(Pages.Dashboard.Home)}>{t("Back Home")}</Button>}
            />
        </div>
    );
}
